<template>
	<div>
		<NavBar />

		<div style="min-height: 80vh">
			<slot />
		</div>

		<CustomFooter :hideOthers="true" />
	</div>
</template>

<script>
	import NavBar from "./components/navbar.vue";
    import CustomFooter from "./components/footer.vue";

	export default {
		name: "DefaultLayout",
		data() {
			return {
			};
		},

		components: {
			NavBar,
            CustomFooter,
		},
	};
</script>
